import { KYMW1407Model } from '../kymw1407.model';
import { GetUseRecordListModel } from '../../kymw1400/vo/get-use-record-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 使用履歴一覧を取得する。
 *
 * @export
 * @class GetUseRecordListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetUseRecordListService extends PlessJsonResponderSub<any> {

  private model: KYMW1407Model = null;
  private vo: GetUseRecordListModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetUseRecordListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CoopCode: this.vo.coopCode,
        Pcode: this.vo.pcode,
        ThisOrderCode: this.vo.thisOrderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1407Model} model
   * @param {GetUseRecordListModel} vo
   * @memberof GetUseRecordListService
   */
  execute(model: KYMW1407Model, vo: GetUseRecordListModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14getUseRecordList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetUseRecordListService
   */
  success(data: any) {
    this.model.updatePcodeInfoList(data);
  }
}
